export default __webpack_public_path__ + "static/media/card-microbit-gray-700x420px.80e17557.png";